import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3cea6b8b")

_pushScopeId("data-v-3cea6b8b")
const _hoisted_1 = { class: "ui__banner_box swiper-container" }
const _hoisted_2 = { class: "swiper-wrapper" }
const _hoisted_3 = { class: "ui__banner_leftBottom" }
const _hoisted_4 = { class: "ui__banner_leftBottom_text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.imgList, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: "swiper-slide",
            key: item.photoIdStr
          }, [
            _createVNode("img", {
              src: item.photoPath
            }, null, 8, ["src"])
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.state.slideIndex + 1) + " / " + _toDisplayString(_ctx.state.imgList.length), 1)
    ])
  ]))
})